import router from "@/router";
import store from "@/store";
import consumerFlow from "./flows/consumer";
import minorFlow from "./flows/minor";
import tutorFlow from "./flows/tutor";
import upgradeToPhysical from "./flows/upgrade_to_physical";

let stepsFlow = consumerFlow;

const AppFlow = {
  stepsFlow,
  setStepsFlow: flow => {

    switch (flow) {
      case "PREPAID_CARD_MINOR":
        stepsFlow = minorFlow;
        break;
      case "TUTOR":
        stepsFlow = tutorFlow;
        break;
      case "UPGRADE_PHYSICAL":
        stepsFlow = upgradeToPhysical;
        break;
      default:
        //stepsFlow = consumerFlow;
        stepsFlow = consumerFlow;
        break;
    }
    console.log("**** setting flow", stepsFlow);
  },
  getRoute: (step, substep) => {
    const routeName = stepsFlow[step][substep];
    return router.options.routes.filter(r => r.name === routeName)[0];
  },
  getCurrentStep: () => {
    return store.state.currentStep;
  },

  getCurrentSubstepIndex: routeName => {
    const stepIndex = store.state.currentStep; //0 based
    const substeps = stepsFlow[stepIndex];
    return substeps.indexOf(routeName);
  },
  getCurrentTotalSubsteps: () => {
    const stepIndex = store.state.currentStep;
    return stepsFlow[stepIndex].length - 1;
  }
};

export default AppFlow;
